import { Lightning, Registry } from '@lightningjs/sdk'
import { rotateArray } from '../../lib/AppHelpers'

export default class MenuCarousel extends Lightning.Component {
  static _template() {
    return {
      MenuWrapper: { h: 180 },
    }
  }

  set data({ items, data, index, brandName }) {
    this._data = data
    this._items = items

    this._dataIndex = index
    this._brandName = brandName

    this._index = index
    this._buildMenu()
  }

  get activeChild() {
    return this.tag('MenuWrapper').children[this._index + 1]
  }

  get hasItems() {
    return this.tag('MenuWrapper').children.length > 0
  }

  _init() {
    this._index = 0
    this._dataIndex = 0
    this._indexSet = true
    this._dir = 'init'
  }

  _active() {
    // this._buildMenu();
  }

  _buildMenu() {
    let items = this._items || []
    const len = items.length
    const half = ~~(len / 2)
    const dividedSet = items.splice(half, len)

    items.unshift(...dividedSet)

    const brandIndex = this._findIndex(items, this._brandName)

    let rotateVal

    if (brandIndex <= 9) {
      rotateVal = 9 - brandIndex
    } else {
      rotateVal = 9 + (items.length - brandIndex)
    }

    rotateArray(items, rotateVal)

    this.tag('MenuWrapper').children = items

    this._half = half

    this.alpha = 1

    setTimeout(() => {
      this._setPosition(8)

      this.signal('menuBuild')
    }, 1000)
  }

  _findIndex(items, brandName) {
    if (!(items && brandName)) return 0
    let brandIndex = -1

    items.forEach((itm, idx) => {
      if (itm.item.brandName.toLowerCase() === brandName.toLowerCase()) {
        brandIndex = idx
      }
    })

    return brandIndex
  }

  _setPosition(index = 0) {
    const children = this.tag('MenuWrapper').children

    const lastIndex =
      (children[this._index] &&
        children[this._index].item &&
        children[this._index].item.dataIndex) ||
      0

    for (const childIdx in children) {
      const child = children[childIdx]
      const offset = childIdx - index + 2

      let { wd, hg, padding } = child.dims
      let cy = 35
      let pos = offset * (wd + padding)

      if (offset === 3) {
        wd = 154
        hg = 154
        cy = 0
      } else if (offset >= 4) {
        wd = 85
        hg = 85
        cy = 35
        pos += 68
      }

      let dur = this._indexSet ? 0 : 0.7

      const endPos = (this._half + 1) * (wd + padding) + (154 + padding - 1)
      const startPos = (this._half - 3) * -126

      if (pos === startPos || childIdx === '0') {
        dur = 0
      }

      if (pos === endPos) {
        dur = 0
      }

      child.size = {
        width: wd,
        height: hg,
        xPosition: pos,
        yPosition: cy,
        smoothDuration: dur,
      }
    }

    this._index = index

    this._indexSet = false

    const newIndex = children[this._index].item.dataIndex
    this._isMenuChangeTimeout = true
    this._menuChangeTimeout = Registry.setTimeout(() => {
      this.fireAncestors('$menuIndexChanged', {
        dir: this._dir,
        index: newIndex,
        previousIndex: lastIndex,
      })
      this._isMenuChangeTimeout = false
    }, 1000)
  }
  _handleDown() {
    return !!this._isMenuChangeTimeout
  }

  _handleRight() {
    Registry.clearTimeout(this._menuChangeTimeout)
    this._dir = 'right'

    this._data = this.tag('MenuWrapper').children

    const item = this._data.shift()
    this._shifted = true
    this._data.push(item)

    this._setPosition(this._index)
  }

  _handleLeft() {
    Registry.clearTimeout(this._menuChangeTimeout)
    this._dir = 'left'

    this._data = this.tag('MenuWrapper').children

    const item = this._data.pop()
    this._shifted = true
    this._data.unshift(item)

    this._setPosition(this._index)
  }

  _handleEnter() {
    this.fireAncestors('$onItemSelect', { item: this.activeChild.item })
  }

  $activeIndex() {
    return this.activeChild.index
  }

  _getFocused() {
    return this.activeChild
  }
}
